"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import clsx from 'clsx';
import styles from './Message.module.scss.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconContextMenu } from '../Icon/components/icons/IconContextMenu.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const Message = flowComponent("Message", (props) => {
  const { type = "responder", children, className } = props;
  const rootClassName = clsx(styles.message, styles[type], className);
  const propsContext = {
    Content: { className: styles.content },
    Header: {
      className: styles.header,
      Button: {
        className: styles.action,
        size: "s",
        variant: "plain",
        color: "secondary"
      },
      ContextMenuTrigger: {
        Button: {
          className: styles.action,
          size: "s",
          variant: "plain",
          color: "secondary",
          children: /* @__PURE__ */ jsx(IconContextMenu, {})
        }
      },
      Text: { className: styles.date },
      Align: {
        className: styles.user
      }
    }
  };
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx("article", { className: rootClassName, children }) });
});

export { Message, Message as default };
//# sourceMappingURL=Message.mjs.map
